import React from 'react';
import s from './icon.module.css';

var meta = {
	"arrow-circle-16": "0 0 16 16",
	"arrow-circle-24": "0 0 16 16",
	"arrow-down-24": "0 0 24 24",
	"arrow-left-24": "0 0 24 24",
	"arrow-right-24": "0 0 24 24",
	"arrow-right-circle-24": "0 0 24 24",
	"arrow-thick-right-16": "0 0 16 16",
	"arrow-up-24": "0 0 24 24",
	"arrow-uturn-24": "0 0 24 24",
	"arrows-apart-16": "0 0 16 16",
	"arrows-expand-24": "0 0 24 24",
	"arrows-expand-40": "0 0 40 40",
	"arrows-left-right-24": "0 0 24 24",
	"arrows-round-24": "0 0 24 24",
	"arrows-squares-16": "0 0 16 16",
	"arrows-up-down-24": "0 0 24 24",
	"bars-horizontal-asc-16": "0 0 16 16",
	"bars-horizontal-asc-24": "0 0 24 24",
	"bars-horizontal-asc-arrow-16": "0 0 16 16",
	"bars-horizontal-asc-arrow-24": "0 0 24 24",
	"bars-horizontal-desc-16": "0 0 16 16",
	"bars-horizontal-desc-24": "0 0 24 24",
	"bars-horizontal-desc-arrow-16": "0 0 16 16",
	"bars-horizontal-desc-arrow-24": "0 0 24 24",
	"bars-horizontal-thick-24": "0 0 24 24",
	"bars-vertical-asc-arrow-16": "0 0 16 16",
	"bars-vertical-asc-arrow-24": "0 0 24 24",
	"bars-vertical-desc-arrow-16": "0 0 16 16",
	"bars-vertical-desc-arrow-24": "0 0 24 24",
	"bars-vertical-thick-24": "0 0 24 24",
	"bars-vertical-thick-32": "0 0 32 32",
	"bell-16": "0 0 16 16",
	"bell-24": "0 0 24 24",
	"bell-32": "0 0 32 32",
	"bell-crossed-24": "0 0 24 24",
	"blueprint-24": "0 0 24 24",
	"blueprint-40": "0 0 40 40",
	"blueprint-crossed-24": "0 0 24 24",
	"blueprint-crossed-40": "0 0 40 40",
	"book-24": "0 0 24 24",
	"bookmark-24": "0 0 24 24",
	"briefcase-16": "0 0 16 16",
	"building-16": "0 0 16 16",
	"bus-12": "0 0 12 12",
	"bus-16": "0 0 16 16",
	"calculator-16": "0 0 16 16",
	"calculator-24": "0 0 24 24",
	"calculator-32": "0 0 32 32",
	"calendar-16": "0 0 16 16",
	"calendar-24": "0 0 24 24",
	"calendar-32": "0 0 32 32",
	"camera-24": "0 0 24 24",
	"camera-40": "0 0 40 40",
	"camera-crossed-24": "0 0 24 24",
	"camera-crossed-40": "0 0 40 40",
	"car-12": "0 0 12 12",
	"car-16": "0 0 16 16",
	"card-24": "0 0 24 24",
	"card-32": "0 0 32 32",
	"check-16": "0 0 16 16",
	"check-24": "0 0 24 24",
	"check-32": "0 0 32 32",
	"check-circle-12": "0 0 12 12",
	"check-circle-16": "0 0 16 16",
	"check-circle-24": "0 0 24 24",
	"check-circle-32": "0 0 32 32",
	"chevron-double-down-24": "0 0 24 24",
	"chevron-double-left-24": "0 0 24 24",
	"chevron-double-right-24": "0 0 24 24",
	"chevron-double-up-24": "0 0 24 24",
	"chevron-down-12": "0 0 12 12",
	"chevron-down-16": "0 0 16 16",
	"chevron-down-24": "0 0 24 24",
	"chevron-down-circle-24": "0 0 24 24",
	"chevron-left-12": "0 0 12 12",
	"chevron-left-16": "0 0 16 16",
	"chevron-left-24": "0 0 24 24",
	"chevron-left-40": "0 0 40 40",
	"chevron-left-circle-24": "0 0 24 24",
	"chevron-right-12": "0 0 12 12",
	"chevron-right-16": "0 0 16 16",
	"chevron-right-24": "0 0 24 24",
	"chevron-right-40": "0 0 40 40",
	"chevron-right-circle-24": "0 0 24 24",
	"chevron-up-12": "0 0 12 12",
	"chevron-up-16": "0 0 16 16",
	"chevron-up-24": "0 0 24 24",
	"chevron-up-circle-24": "0 0 24 24",
	"circle-crossed-24": "0 0 24 24",
	"circle-crossed-32": "0 0 32 32",
	"clip-24": "0 0 24 24",
	"clip-32": "0 0 32 32",
	"clipboard-24": "0 0 24 24",
	"clipboard-32": "0 0 32 32",
	"clock-24": "0 0 24 24",
	"clock-arrowed-16": "0 0 16 16",
	"clock-arrowed-24": "0 0 24 24",
	"clock-arrowed-32": "0 0 32 32",
	"compass-circle-24": "0 0 24 24",
	"compass-circle-32": "0 0 32 32",
	"copy-24": "0 0 24 24",
	"crown-circle-16": "0 0 16 16",
	"crown-circle-24": "0 0 24 24",
	"custom-deal-16": "0 0 16 16",
	"custom-deal-24": "0 0 24 24",
	"dashed-frame-24": "0 0 24 24",
	"desktop-24": "0 0 24 24",
	"document-16": "0 0 16 16",
	"document-24": "0 0 24 24",
	"document-32": "0 0 32 32",
	"document-arrow-24": "0 0 24 24",
	"document-arrow-32": "0 0 32 32",
	"document-arrow-down-24": "0 0 24 24",
	"document-check-24": "0 0 24 24",
	"document-check-32": "0 0 32 32",
	"document-clock-24": "0 0 24 24",
	"document-clock-32": "0 0 32 32",
	"document-copy-24": "0 0 24 24",
	"document-copy-32": "0 0 32 32",
	"document-doc-24": "0 0 24 24",
	"document-empty-24": "0 0 24 24",
	"document-empty-32": "0 0 32 32",
	"document-jpg-24": "0 0 24 24",
	"document-lock-32": "0 0 32 32",
	"document-minus-24": "0 0 24 24",
	"document-minus-32": "0 0 32 32",
	"document-pdf-24": "0 0 24 24",
	"document-pdf-arrow-24": "0 0 24 24",
	"document-plus-24": "0 0 24 24",
	"document-plus-32": "0 0 32 32",
	"document-png-24": "0 0 24 24",
	"document-times-24": "0 0 24 24",
	"document-times-32": "0 0 32 32",
	"document-xls-24": "0 0 24 24",
	"document-zigzag-24": "0 0 24 24",
	"document-zigzag-32": "0 0 32 32",
	"door-in-24": "0 0 24 24",
	"door-out-16": "0 0 16 16",
	"door-out-24": "0 0 24 24",
	"dots-horizontal-16": "0 0 16 16",
	"dots-horizontal-24": "0 0 24 24",
	"dots-horizontal-32": "0 0 32 32",
	"download-24": "0 0 24 24",
	"education-24": "0 0 24 24",
	"envelope-24": "0 0 24 24",
	"envelope-32": "0 0 32 32",
	"excel-24": "0 0 24 24",
	"excel-32": "0 0 32 32",
	"exclamation-circle-16": "0 0 16 16",
	"exclamation-circle-24": "0 0 24 24",
	"exclamation-triangle-16": "0 0 16 16",
	"exclamation-triangle-24": "0 0 24 24",
	"exclamation-triangle-32": "0 0 32 32",
	"eye-16": "0 0 16 16",
	"eye-24": "0 0 24 24",
	"eye-crossed-24": "0 0 24 24",
	"facebook-16": "0 0 16 16",
	"facebook-24": "0 0 24 24",
	"finger-draw-24": "0 0 24 24",
	"folder-16": "0 0 16 16",
	"folder-24": "0 0 24 24",
	"folder-32": "0 0 32 32",
	"gear-24": "0 0 24 24",
	"globe-24": "0 0 24 24",
	"grid-24": "0 0 24 24",
	"heart-16": "0 0 16 16",
	"heart-24": "0 0 24 24",
	"heart-32": "0 0 32 32",
	"heart-hollow-16": "0 0 16 16",
	"heart-hollow-24": "0 0 24 24",
	"heart-hollow-32": "0 0 32 32",
	"helmet-16": "0 0 16 16",
	"house-24": "0 0 24 24",
	"house-checked-empty-24": "0 0 24 24",
	"house-copy-24": "0 0 24 24",
	"house-copy-32": "0 0 32 32",
	"house-heart-24": "0 0 24 24",
	"house-living-24": "0 0 24 24",
	"house-lock-16": "0 0 16 16",
	"house-lock-24": "0 0 24 24",
	"house-magnifier-24": "0 0 24 24",
	"house-one-24": "0 0 24 24",
	"house-persent-24": "0 0 24 24",
	"house-plus-24": "0 0 24 24",
	"image-24": "0 0 24 24",
	"in-construction-24": "0 0 24 24",
	"information-circle-16": "0 0 16 16",
	"information-circle-24": "0 0 24 24",
	"information-circle-32": "0 0 32 32",
	"instagram-16": "0 0 16 16",
	"instagram-24": "0 0 24 24",
	"key-16": "0 0 16 16",
	"key-32": "0 0 32 32",
	"layers-24": "0 0 24 24",
	"letter-range-asc-16": "0 0 16 16",
	"letter-range-asc-24": "0 0 24 24",
	"letter-range-desc-16": "0 0 16 16",
	"letter-range-desc-24": "0 0 24 24",
	"lightbulb-24": "0 0 24 24",
	"lightbulb-32": "0 0 32 32",
	"lightning-circle-16": "0 0 24 24",
	"lightning-circle-24": "0 0 24 24",
	"link-16": "0 0 16 16",
	"link-24": "0 0 24 24",
	"link-32": "0 0 32 32",
	"list-24": "0 0 24 24",
	"lock-closed-16": "0 0 16 16",
	"lock-closed-24": "0 0 24 24",
	"lock-closed-32": "0 0 32 32",
	"lock-opened-16": "0 0 16 16",
	"lock-opened-24": "0 0 24 24",
	"lock-opened-32": "0 0 32 32",
	"m2-bookmark-24": "0 0 24 24",
	"m2-bookmark-32": "0 0 32 32",
	"m2-bookmark-circle-24": "0 0 24 24",
	"m2-building-24": "0 0 24 24",
	"m2-building-multiple-24": "0 0 24 24",
	"m2-building-multiple-32": "0 0 32 32",
	"m2-building-wing-24": "0 0 24 24",
	"m2-calendar-24": "0 0 24 24",
	"m2-calendar-32": "0 0 32 32",
	"m2-chair-24": "0 0 24 24",
	"m2-chart-asc-24": "0 0 24 24",
	"m2-chat-24": "0 0 24 24",
	"m2-chat-32": "0 0 32 32",
	"m2-chat-notified-24": "0 0 24 24",
	"m2-chat-notified-32": "0 0 32 32",
	"m2-document-check-24": "0 0 24 24",
	"m2-document-check-empty-24": "0 0 24 24",
	"m2-document-pen-16": "0 0 16 16",
	"m2-document-pen-24": "0 0 24 24",
	"m2-document-pen-32": "0 0 32 32",
	"m2-folder-clip-16": "0 0 16 16",
	"m2-folder-clip-24": "0 0 24 24",
	"m2-folder-clip-32": "0 0 32 32",
	"m2-gear-24": "0 0 24 24",
	"m2-gear-32": "0 0 32 32",
	"m2-heart-24": "0 0 24 24",
	"m2-heart-32": "0 0 32 32",
	"m2-heart-circle-24": "0 0 24 24",
	"m2-house-checked-24": "0 0 25 24",
	"m2-house-checked-32": "0 0 32 32",
	"m2-house-stroked-24": "0 0 24 24",
	"m2-house-stroked-32": "0 0 32 32",
	"m2-houses-24": "0 0 24 24",
	"m2-houses-32": "0 0 32 32",
	"m2-lock-16": "0 0 16 16",
	"m2-lock-24": "0 0 24 24",
	"m2-lock-32": "0 0 32 32",
	"m2-magnifier-24": "0 0 24 24",
	"m2-magnifier-32": "0 0 32 32",
	"m2-note-pen-24": "0 0 24 24",
	"m2-note-pen-32": "0 0 32 32",
	"m2-paintroller-24": "0 0 24 24",
	"m2-paintroller-32": "0 0 32 32",
	"m2-percentage-circle-16": "0 0 16 16",
	"m2-percentage-circle-24": "0 0 24 24",
	"m2-percentage-circle-32": "0 0 32 32",
	"m2-person-16": "0 0 16 16",
	"m2-person-24": "0 0 24 24",
	"m2-person-32": "0 0 32 32",
	"m2-person-circle-24": "0 0 24 24",
	"m2-person-circle-32": "0 0 32 32",
	"m2-person-tie-16": "0 0 16 16",
	"m2-person-tie-24": "0 0 24 24",
	"m2-person-tie-32": "0 0 32 32",
	"m2-piechart-24": "0 0 24 24",
	"m2-piechart-32": "0 0 32 32",
	"m2-receipt-24": "0 0 24 24",
	"m2-squares-24": "0 0 24 24",
	"m2-squares-32": "0 0 32 32",
	"m2-squares-quad-24": "0 0 24 24",
	"m2-squares-quad-32": "0 0 32 32",
	"m2-star-16": "0 0 16 16",
	"m2-star-24": "0 0 24 24",
	"m2-star-32": "0 0 32 32",
	"m2-tags-percent-24": "0 0 24 24",
	"m2-tags-percent-32": "0 0 32 32",
	"m2-tree-24": "0 0 24 24",
	"m2-wallet-16": "0 0 16 16",
	"m2-wallet-24": "0 0 24 24",
	"magnifier-16": "0 0 16 16",
	"magnifier-24": "0 0 24 24",
	"magnifier-32": "0 0 32 32",
	"magnifier-heart-24": "0 0 24 24",
	"magnifier-minus-24": "0 0 24 24",
	"magnifier-plus-24": "0 0 24 24",
	"magnifier-plus-32": "0 0 32 32",
	"map-16": "0 0 16 16",
	"map-24": "0 0 24 24",
	"map-32": "0 0 32 32",
	"megaphone-24": "0 0 24 24",
	"menu-24": "0 0 24 24",
	"message-16": "0 0 16 16",
	"message-24": "0 0 24 24",
	"message-32": "0 0 32 32",
	"microphone-16": "0 0 16 16",
	"microphone-24": "0 0 24 24",
	"microphone-32": "0 0 32 32",
	"minus-16": "0 0 16 16",
	"minus-24": "0 0 24 24",
	"minus-circle-16": "0 0 16 16",
	"minus-circle-24": "0 0 24 24",
	"new-client-24": "0 0 24 24",
	"note-sign-24": "0 0 24 24",
	"notes-24": "0 0 24 24",
	"number-range-asc-16": "0 0 16 16",
	"number-range-asc-24": "0 0 24 24",
	"number-range-desc-16": "0 0 16 16",
	"number-range-desc-24": "0 0 24 24",
	"ok-24": "0 0 24 24",
	"panorama-24": "0 0 24 24",
	"panorama-32": "0 0 32 32",
	"pause-24": "0 0 24 24",
	"pedestrian-12": "0 0 12 12",
	"pedestrian-16": "0 0 16 16",
	"pencil-16": "0 0 16 16",
	"pencil-24": "0 0 24 24",
	"pencil-32": "0 0 32 32",
	"person-16": "0 0 16 16",
	"person-circle-24": "0 0 24 24",
	"person-rounded-16": "0 0 16 16",
	"person-tie-circle-24": "0 0 24 24",
	"persons-24": "0 0 24 24",
	"phone-16": "0 0 16 16",
	"phone-24": "0 0 24 24",
	"phone-32": "0 0 32 32",
	"phone-circle-16": "0 0 16 16",
	"phone-circle-24": "0 0 24 24",
	"phone-circle-32": "0 0 32 32",
	"phone-eye-16": "0 0 16 16",
	"phone-incoming-24": "0 0 24 24",
	"piechart-24": "0 0 24 24",
	"piechart-32": "0 0 32 32",
	"placemark-16": "0 0 16 16",
	"placemark-24": "0 0 24 24",
	"placemark-32": "0 0 32 32",
	"plus-16": "0 0 16 16",
	"plus-24": "0 0 24 24",
	"plus-circle-16": "0 0 16 16",
	"plus-circle-24": "0 0 24 24",
	"plus-circle-32": "0 0 32 32",
	"power-switch-24": "0 0 24 24",
	"presentation-24": "0 0 24 24",
	"printer-24": "0 0 24 24",
	"question-24": "0 0 24 24",
	"question-circle-16": "0 0 16 16",
	"question-circle-24": "0 0 24 24",
	"rgr-16": "0 0 16 16",
	"rocket-16": "0 0 16 16",
	"rosreestr-arrow-24": "0 0 24 24",
	"rouble-24": "0 0 24 24",
	"rouble-32": "0 0 32 32",
	"ruler-24": "0 0 24 24",
	"safe-16": "0 0 16 16",
	"safe-24": "0 0 24 24",
	"safe-32": "0 0 32 32",
	"send-16": "0 0 16 16",
	"send-24": "0 0 24 24",
	"send-32": "0 0 32 32",
	"settings-16": "0 0 16 16",
	"settings-24": "0 0 24 24",
	"settings-32": "0 0 32 32",
	"share-16": "0 0 16 16",
	"share-24": "0 0 24 24",
	"share-32": "0 0 32 32",
	"shield-24": "0 0 24 24",
	"shield-check-24": "0 0 24 24",
	"shield-check-32": "0 0 32 32",
	"signal-24": "0 0 24 24",
	"smartphone-24": "0 0 24 24",
	"square-arrow-16": "0 0 16 16",
	"square-arrow-24": "0 0 24 24",
	"square-arrow-32": "0 0 32 32",
	"star-circle-24": "0 0 24 24",
	"tag-24": "0 0 24 24",
	"tag-32": "0 0 32 32",
	"target-24": "0 0 24 24",
	"telegram-16": "0 0 16 16",
	"telegram-24": "0 0 24 24",
	"thumb-up-24": "0 0 24 24",
	"timelapse-16": "0 0 16 16",
	"timelapse-24": "0 0 24 24",
	"times-16": "0 0 16 16",
	"times-24": "0 0 24 24",
	"times-32": "0 0 32 32",
	"times-circle-16": "0 0 16 16",
	"times-circle-24": "0 0 24 24",
	"times-circle-32": "0 0 32 32",
	"traffic-light-24": "0 0 24 24",
	"trashbin-16": "0 0 16 16",
	"trashbin-24": "0 0 24 24",
	"trashbin-32": "0 0 32 32",
	"triangle-arrow-16": "0 0 16 16",
	"triangle-arrow-24": "0 0 24 24",
	"triangle-arrow-32": "0 0 32 32",
	"triangle-down-16": "0 0 16 16",
	"triangle-up-16": "0 0 16 16",
	"twitter-24": "0 0 24 24",
	"undo-16": "0 0 16 16",
	"undo-24": "0 0 24 24",
	"undo-32": "0 0 32 32",
	"upload-24": "0 0 24 24",
	"video-24": "0 0 24 24",
	"vk-16": "0 0 16 16",
	"vk-24": "0 0 24 24",
	"vtb-logo-24": "0 0 24 24",
	"whatsapp-24": "0 0 24 24"
};

// will be migrated to TS in [CMS-1704]
var aliases_1 = {
    close: 'times',
    cross: 'times',
};

const registry = meta;
const sizes = {
    xs: 12,
    s: 16,
    m: 24,
    l: 32,
    xl: 40,
};
const Icon = ({ name: externalName, size: externalSize = 'm', color }) => {
    const size = sizes[externalSize];
    const name = aliases_1[externalName] || externalName;
    const id = `${name}-${size}`;
    if (!registry[id]) {
        return null;
    }
    return (React.createElement("i", { className: s.box, style: Object.assign({ fontSize: `${size}px`, lineHeight: `${size}px` }, (color && { color })) },
        React.createElement("svg", { width: size, height: size, className: s.svg, viewBox: registry[id] },
            React.createElement("use", { xlinkHref: `#${id}` }))));
};

export { Icon as default };
